<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules'

const modules = [Autoplay, EffectFade, Navigation, Pagination]

import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

definePageMeta({
  title: "企画・イベント",
})
</script>

<style>
.swiper {
  width: 100%;
  height: 100%;
  padding-bottom: 32px;
}

.swiper-slide {
  background-position: center;
  background-size: cover;
}

.swiper-slide img {
  display: block;
  height: 100%;
}
</style>

<template>
  <article class="flex flex-col items-center max-w-[900px] mx-auto px-[8px]">
    <Ribbon class="mt-4 mb-4 text-md md:text-2xl">
      企画・イベント
    </Ribbon>

    <div class="w-full h-[calc(100vh-256px)] md:w-[calc((100vh-256px-32px)*(210/297))]">
      <Swiper 
        effect="fade" 
        :navigation="true"
        :loop="true"
        :pagination="{
          clickable: true,
        }" 
        :autoplay="{
          delay: 2500,
          disableOnInteraction: true,
        }"
        :modules="modules"
        >
        <SwiperSlide v-for="i in 2">
          <img :src="`./img/event/${i}.jpg`" />
        </SwiperSlide>
      </Swiper>
    </div>

    <div class="mt-2 mb-2">
      <NuxtLink class="btn btn-primary" to="/pdf/event.pdf" target="_blank">
        PDFで開く
      </NuxtLink>
    </div>
  </article>
</template>